import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAreaPpr } from './api';

export const path = '/ppr/area/list/:id';
export const getPath = (id: string) => `/ppr/area/list/${id}`;

const PageAreaPpr: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();

  const AreaPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
      area: () => getAreaPpr(+id),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <AreaPpr {...props} />;
};

export default PageAreaPpr;
